var tool = {
    //匹配字符串里所有的网址  返回值:一组数组格式的Array url地址
    getUrlArr: function (urlstirng) {
        var reg = new RegExp("(https?|ftp|file|http)://[-A-Za-z0-9+&@@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@@#/%=~_|]", "ig");
        var r = urlstirng.match(reg);
        if (r != null) return r;
        return null; //返回参数值
    },
    //淘口令正则表达式生成
    getRexage: function () {
        var kh = '(\\(([\\S*]+)\\))';
        var regArr = ['《', '€', '\\$', '\\¥', '\\¢', '\\₴', '￥'],
            regNum = regArr.length,
            le = '';
        for (var i = 0; i < regNum; i++) {
            if (le) {
                le += "|" + "(" + regArr[i] + "([\\S*]+)" + regArr[i] + ")";
            } else {
                le += "(" + regArr[i] + "([\\S*]+)" + regArr[i] + ")";
            }
            ;
        }
        le = le + "|" + kh;
        return "/" + le + "/g";
    },
    //提示信息
    elemTips: function (_this, type, msg) {
        _this.$message({type: type, message: msg});
    },
    //获取地址栏部分参数
    GetPartParam:function (url, sParamName) {
	    if (!sParamName) {
	        return '';
	    };
	    var reg = new RegExp("(&|\/|[\?])" + sParamName + "=([^&]*)(&|$)");
	    var r = url.match(reg);
	    console.log(r,'rrrrrrrrrrr')
	    if(r){
	    	if(r[2].indexOf('#')){
	    		return decodeURIComponent(r[2].split('#')[0]);
	    	}else{
	    		return decodeURIComponent(r[2]);
	    	};
	    }else{
	    	return '';
	    };
//	    return r ? decodeURIComponent(r[2]) : '';
	},  
    compressImg: function (img) {
        let url;
        if (img) {
            if (img.indexOf('http://oss') != -1) {
                url = img + '?x-oss-process=image/resize,m_fixed,h_288,w_288'
                return url;
            }
            if (img.indexOf('http://cdni.ztsite.cn') != -1) {
                url = img + '?x-oss-process=image/resize,h_400'
                return url;
            }
            if (img.indexOf('alicdn.com') != -1) {
               let pattern = /_(\d{3}).(\d{3})/
                if(pattern.test(img)){
                    url = img.replace(/_(\d{3}).(\d{3})/g, '_400x400')
                }else {
                    url = img + '_400x400.jpg'
                }
                return url;
            }
            if (img.indexOf('img.tkeasy.com') != -1) {

                url = img + '_400x400.jpg';
                return url;
            }
            if (img.indexOf('gd4.alicdn.com') != -1) {
                url = img + '_400x400.jpg';
                return url;
            }
        }
        return img
    },
    tkEasyImg: function (pic) {
        if (pic.indexOf('img.tkeasy.com') != -1) {
            pic = pic.replace('img.tkeasy.com', process.env.TKY_PATH)
        }
        return pic
    },
    //设置cookie作用域
	setCookie:function(name,value,d){
        console.log(name, value)
        var str = name + "=" + escape(value) + ";domain=.zutuan.cn;path= /";//正式
//		var str = name + "=" + escape(value) + ";domain=.cdnzutuan.cn;path= /";//线上
        var date = new Date();
        date.setTime(date.getTime() + d * 24 * 60 * 60 * 1000);

        str += ";expires=" + date.toGMTString();
        console.log(str)
        document.cookie = str;
    },
    //获取cookie
    getCookie:function(){
    	let value;
	    var allcookies = document.cookie;
	    //索引长度，开始索引的位置
	    var cookie_pos = allcookies.indexOf(cookie_name);
	    // 如果找到了索引，就代表cookie存在,否则不存在
	    if (cookie_pos != -1) {
	        // 把cookie_pos放在值的开始，只要给值加1即可
	        //计算取cookie值得开始索引，加的1为“=”
	        cookie_pos = cookie_pos + cookie_name.length + 1;
	        //计算取cookie值得结束索引
	        var cookie_end = allcookies.indexOf(";", cookie_pos);
	        if (cookie_end == -1) {
	            cookie_end = allcookies.length;
	        }
	        //得到想要的cookie的值
	        value = unescape(allcookies.substring(cookie_pos, cookie_end));
	    }
	    return value;
    },
    //判断是否是ie8及以下浏览器
    ieVertion:function(){
    	var DEFAULT_VERSION = 8.0;  
	    var ua = navigator.userAgent.toLowerCase();  
	    var isIE = ua.indexOf("msie")>-1;  
	    var safariVersion;  
	    if(isIE){  
	    safariVersion =  ua.match(/msie ([\d.]+)/)[1];  
	    }  
	    if(safariVersion <= DEFAULT_VERSION ){  
	      alert('系统检测到您正在使用ie8及以下内核的浏览器，不能实现完美体验，请更换或升级浏览器访问！')
	    };
    },
    //获取base64图片大小
    base64Size:function(base64url) {
        //获取base64图片大小，返回MB数字
        var str = base64url.replace('data:image/png;base64,', '');
        var equalIndex = str.indexOf('=');
        if(str.indexOf('=')>0) {
            str=str.substring(0, equalIndex);
        }
        var strLength=str.length;
        var fileLength=parseInt(strLength-(strLength/8)*2);
        // 由字节转换为MB
        var size = "";
        size = (fileLength/(1024 * 1024)).toFixed(2);
        var sizeStr = size + "";                        //转成字符串
        var index = sizeStr.indexOf(".");                    //获取小数点处的索引
        var dou = sizeStr.substr(index + 1 ,2)            //获取小数点后两位的值
        if(dou == "00"){                                //判断后两位是否为00，如果是则删除00                
            return sizeStr.substring(0, index) + sizeStr.substr(index + 3, 2)
        }
        return size;
    }
};
const LoadUser = 'http://user.zt.cn:7777/api/proxy';
const LoadInfo = 'http://info.zt.cn:7777/api/proxy';
const LoadTool = 'http://tool.zt.cn:7777/api/proxy';
const LoadAdmin = 'http://admin.zt.cn:7777/api/proxy';
const LoadCallback = 'http://callback.zt.cn:7777/api/proxy';
const LoadBuy = 'http://buy.zt.cn:7777/api/proxy';
const reqUrl = 'http://test.zt.cn';
export {
    tool, LoadUser, LoadInfo, LoadTool, LoadAdmin, LoadCallback, LoadBuy, reqUrl
}
//处理图片跨域限制
export default function handlePic(pic) {
    if (pic.indexOf(process.env.TKY_PATH) != -1) {
        pic = pic.replace(process.env.TKY_PATH, 'img.tkeasy.com')
    }
    if (pic.indexOf('img.alicdn.com') != -1) {
        pic = pic.replace('img.alicdn.com', process.env.TB_PATH)
    }
    if (pic.indexOf('gd3.alicdn.com') != -1) {
        pic = pic.replace('gd3.alicdn.com', process.env.TB_PATH)
    }
    return pic
}